import { render } from "./ProfileInfo.vue?vue&type=template&id=596d4c85&scoped=true"
import script from "./profile_info.js?vue&type=script&lang=js&external"
export * from "./profile_info.js?vue&type=script&lang=js&external"

import "./ProfileInfo.vue?vue&type=style&index=0&id=596d4c85&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596d4c85"]])

export default __exports__